var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"image-upload"},[_c('file-uploader',{attrs:{"editor":_vm.editor},on:{"uploaded":_vm.fileUploaded,"error":_vm.handleError}})],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"markdown-editor"},[_c('textarea',{attrs:{"id":"simple-mde"}})])
}]

export { render, staticRenderFns }